exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Icon__icon{background:no-repeat 50%/contain;display:inline-block}", ""]);

// Exports
exports.locals = {
	"icon": "Icon__icon"
};